import axios from "@/config/axiosConfig";
import { CREATE_CASH_RECEIPT, GET_CASH_RECEIPTS, CASH_RECEIPT_REQUEST, UPDATE_CASH_RECEIPT, DELETE_CASH_RECEIPT, CASH_RECEIPT_REQUEST_FAILURE, GET_CASH_RECEIPTS_PAGE,
  CASH_RECEIPT_REQUEST_SUCCESS
 } from "../types";

export const getCashReceiptsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_RECEIPT_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id'
      };
      return axios.get("/cash-receipt/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CASH_RECEIPTS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
    }
  };
};

 export const getCashReceipts = (include, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_RECEIPT_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = { finyearId: fin?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/cash-receipt/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CASH_RECEIPTS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getValidatedIncrementedVchNoCashReceipt = (bookId, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if(bookId) {
        params = { ...params, bookId: bookId };
      }
      const response = await axios.get("/cash-receipt/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getCashReceiptByRange = (billId, from, to, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/cash-receipt/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getCashReceiptById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_RECEIPT_REQUEST });
    
      return axios.get(`/cash-receipt/get/${id}`).then((response) => {
        dispatch({ type: CASH_RECEIPT_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createCashReceipt = (data, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      dispatch({ type: CASH_RECEIPT_REQUEST });
      return axios.post("/cash-receipt/add", data,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: fin?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_CASH_RECEIPT, payload: response.data });
        } else {
          dispatch({
            type: CASH_RECEIPT_REQUEST_FAILURE,
            error: "Cash Receipt create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateCashReceipt = (id, data, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_RECEIPT_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      return axios.put("/cash-receipt/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Receipt?.Company_Id || auth.company?.id,
            finyearId: data.Receipt?.Finyear_Id || fin?.id,
            customerId: data.Receipt?.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_CASH_RECEIPT,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: CASH_RECEIPT_REQUEST_FAILURE,
            error: "Cash Receipt update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteCashReceipt = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_RECEIPT_REQUEST });
      const { auth } = getState();
      return axios.delete(`/cash-receipt/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_CASH_RECEIPT, id: id });
          const include = ['id', 'Vch_No', 'Book_Id', 'Date'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { transaction: { cashReceipt: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getCashReceiptsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_RECEIPT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};